
import { ISession } from '../../state/stores/Session/SessionModel';
import { TIMEOUT } from '../../config/designSystem/Colors';
import { useIsReadySession } from '../session/useIsReadySession';
import { useStores } from '../useStores';

type ContentPropForHook = {
    id: string,
    type: 'CONTENT_TEXT' | 'CONTENT_VIDEO' | 'CONTENT_AUDIO' | 'SURVEY' | 'QUESTION' | 'EXERCISE' | 'CHALLENGE'
}


export const useFetchedContentSession = (session: ISession) => {

  const rootStore = useStores();

  const {loading, error} = useIsReadySession(session);

  const fetchOneContent =async (content: ContentPropForHook) => {
    console.log('useFetchedContentSession.fetchOneContent', content);
    switch (content.type) {

    case 'CONTENT_TEXT':
    case 'CONTENT_VIDEO':
    case 'CONTENT_AUDIO':
      await rootStore?.content.fetchContentIfNotExist(content.id);
      setTimeout(()=> {
        rootStore?.content.setError(content.id);
      }, TIMEOUT);
      break;
    case 'SURVEY':
      await rootStore?.survey.loadSurvey(content.id, true);
      break;
    case 'QUESTION':
      await rootStore?.question.fetchQuestionIfNotExist(content.id);
      setTimeout(()=> {
        rootStore?.question.setError(content.id);
      }, TIMEOUT);
      break;
    case 'EXERCISE':
      await rootStore?.exercise.fetchExerciseIfNotExist(content.id);
      setTimeout(()=> {
        rootStore?.exercise.setError(content.id);
      }, TIMEOUT);
      break;
    }
  };

  const fetch = async () => {
    console.log('useFetchedContentSession.fetch', !!session.sessionSteps);
    if (session?.sessionSteps) {
      await Promise.all(session.sessionSteps.map(async ss => {
        console.log('fetch sessionstep', ss.contentId);
        if(ss.contentId) {
          await fetchOneContent({id: ss.contentId, type: ss.contentType});
        }
      }));

    }
  };

  const fetchWithFrames = async (pathId?: string) => {
    await fetch();
    rootStore?.session.addFramesWrapper(pathId, session._id);
  };



  return {loading, error, fetch,fetchWithFrames};
};